import React from 'react';
import faviconImage from '@/assets/favicon.svg';

interface AppLogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const AppLogo: React.FC<AppLogoProps> = ({ 
  size = 'medium',
  className = '' 
}) => {
  const sizeClasses = {
    small: 'w-12 h-12',
    medium: 'w-16 h-16',
    large: 'w-20 h-20',
  };

  const iconSizes = {
    small: 'w-7 h-7',
    medium: 'w-10 h-10',
    large: 'w-12 h-12',
  };

  return (
    <div className={`${className}`}>
      <div className={`${sizeClasses[size]} bg-gradient-to-r from-[#FF2A2E] to-[#FEB03A] rounded-2xl flex items-center justify-center`}>
        <img src={faviconImage} alt="App Logo" className={iconSizes[size]} />
      </div>
    </div>
  );
};

export default AppLogo; 